import React from "react";
import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "../components/SubpageHeader";
import ContactSection from "../components/ContactSection";

import "styles/pages/page-sponsors.scss";

const SponsorsPage = ({ pageContext }) => {
  const sponsors = pageContext.data;

  const lang = pageContext.language?.slug;
  return (
    <Layout lang={lang}>
      <Seo title={sponsors.title} />
      <SubpageHeader lang={lang} title={sponsors.title} />
      <section className="section-sponsors">
        <div className="container">
          <h2 className="section-sponsors__title">{sponsors.subtitle}</h2>
          <div className="row">
            <div className="col-lg-6">
              <div
                className="section-sponsors__text"
                dangerouslySetInnerHTML={{ __html: sponsors.text }}
              />
            </div>
          </div>
        </div>
      </section>
      <ContactSection
        sponsors
        className="section-sponsors__contact"
        lang={lang}
      />
    </Layout>
  );
};

export default SponsorsPage;
